import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
/** Details for anonymous authentication. */
export function AnonymousDetails() {
    return (_jsx(Text.Paragraph, { children: "The user can start a conversation as anonymous." }));
}
